"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sushiKava = void 0;
exports.sushiKava = {
    minichef: '0xf731202A3cf7EfA9368C2d7bD613926f7A144dB5',
    complexRewarderTime: '0xeaf76e3bD36680D98d254B378ED706cb0DFBfc1B',
    bentoBox: '0xc35DADB65012eC5796536bD9864eD8773aBc74C4',
    router: '0xbE811A0D44E2553d25d11CB8DC0d3F0D0E6430E6',
};
